export const getLogoLink = (userData, userRole) => {
  const managersFeedFlags = ['buildingAnalyticsAvailable', 'communityCalendar']
  const availablefeedFlags = userData ? userData.buildingId : undefined

  const getFirstAvailableFeedFlag = (choosenArray) => {
    return choosenArray
      .map((feedFlag) => {
        if (availablefeedFlags[feedFlag]) {
          return feedFlag
        } else {
          return null
        }
      })
      .filter((x) => x)[0]
  }

  if (userRole === 'Staff') {
    return '/dashboard/user-panel/profile'
  } else if (userRole === 'ShiftManager') {
    return '/dashboard/calendar'
  } else {
    switch (getFirstAvailableFeedFlag(managersFeedFlags)) {
      case 'buildingAnalyticsAvailable':
        return '/dashboard/building-analytics'
      case 'communityCalendar':
        return '/dashboard/calendar'
      default:
        return '/dashboard/clients'
    }
  }
}
